import { post } from '../utils/http';
import config from '../config.js'

/**
 * 登录
 * @param {*} params 
 */
export function login(params) {
  return post(`/api/${config.companyId}/login`, params)
}